import React from 'react';
import PropTypes from 'prop-types';
import { DetailsLayout, PhoneLink } from '../../common';
import format from 'date-fns/format';

function InsuranceDetails({ provider, policyHolder, caseManager }) {
  return (
    <DetailsLayout heading={provider.name}>
      {provider.policyNumber && (
        <div>Policy Number: {provider.policyNumber}</div>
      )}
      {provider.groupNumber && <div>Group Number: {provider.groupNumber}</div>}
      {provider.primaryPhoneNumber && (
        <PhoneLink
          ext={provider.phoneExtension}
          label="Phone"
          tel={provider.primaryPhoneNumber}
        />
      )}
      {policyHolder && (policyHolder.firstName || policyHolder.lastName) && (
        <div>
          Policy Holder: {policyHolder.firstName} {policyHolder.lastName}
        </div>
      )}
      {policyHolder && policyHolder.birthday && (
        <div>Birth Date: {format(policyHolder.birthday, 'M/D/YYYY')}</div>
      )}
      {caseManager && (caseManager.firstName || caseManager.lastName) && (
        <div>
          Case Manager: {caseManager.firstName} {caseManager.lastName}
        </div>
      )}
      {caseManager.primaryPhoneNumber && (
        <PhoneLink
          ext={caseManager.phoneExtension}
          label="Case Manager Phone"
          tel={caseManager.primaryPhoneNumber}
        />
      )}
      {provider.notes && (
        <div>
          {<span>Notes: </span>}
          {provider.notes}
        </div>
      )}
    </DetailsLayout>
  );
}

InsuranceDetails.propTypes = {
  caseManager: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneExtension: PropTypes.string,
    primaryPhoneNumber: PropTypes.string,
  }),
  policyHolder: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  provider: PropTypes.shape({
    name: PropTypes.string,
    groupNumber: PropTypes.string,
    notes: PropTypes.string,
    policyNumber: PropTypes.string,
    phoneExtension: PropTypes.string,
    primaryPhoneNumber: PropTypes.string,
  }),
};

export default InsuranceDetails;



// WEBPACK FOOTER //
// ./src/modules/InsurancePage/components/InsuranceDetails.js